import * as React from "react";
import { Pressable, Text, View } from "react-native";
import { Stack, useNavigation, useRouter } from "expo-router";
import { StackActions } from "@react-navigation/native";

import { HeaderX } from "~/components/HeaderElements";
import Logo from "~/assets/logo.svg";
import { useAccountStore } from "~/stores/space";
import { ListContainer, ListItem } from "~/ui/List";

export default function Collection() {
  const { store: account } = useAccountStore();
  const { push } = useRouter();
  const navigation = useNavigation();

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: "Select space for collection",
          headerRight: () => (
            <HeaderX
              onPress={() => {
                navigation.getParent()?.dispatch(StackActions.pop());
              }}
            />
          ),
        }}
      />

      <View className="gap-y-4">
        {account.spaces.size > 0 && (
          <ListContainer title="Select a space to proceed">
            {account.spacesAsArrayWithoutBacklog.map((space) => (
              <ListItem key={space.id} asChild>
                <Pressable
                  onPress={() => {
                    push({
                      pathname:
                        "/(app)/(authenticated)/[account]/collection/form",
                      params: { account: account.slug, spaceId: space.id },
                    });
                  }}
                >
                  <View className="flex-row items-center">
                    <Logo width={24} height={24} />
                    <Text className="text-base text-white">
                      {space.displayName ?? space.slug}
                    </Text>
                  </View>
                  <Text className="text-text-secondary text-base">125</Text>
                </Pressable>
              </ListItem>
            ))}
          </ListContainer>
        )}
      </View>
    </>
  );
}
